import {Button} from "@mui/material";
import React from "react";

export const KPIComparisonControls = ({
    activeWindow,
    userDefinedWindow,
    setUserDefinedWindow,
    setActiveWindow,
    defaultStart,
    defaultMiddle,
    defaultEnd
}) => {

    return <span className={"control"}>
        <Button
            onClick={() => {
                setActiveWindow({
                    previous: {
                        start: userDefinedWindow.previous.start || activeWindow.previous.start || defaultStart,
                        end: userDefinedWindow.previous.end || activeWindow.previous.end || defaultMiddle
                    },
                    current: {
                        start: userDefinedWindow.current.start || activeWindow.current.start || defaultMiddle,
                        end: userDefinedWindow.current.end || activeWindow.current.end || defaultEnd
                    }
                });
                setUserDefinedWindow({
                    previous: {start: null, end: null},
                    current: {start: null, end: null}
                });
            }}
            variant={"contained"}
        >Update Date Ranges</Button>
    </span>
}